module.exports = __webpack_public_path__ + "static/media/IPHONEBOX.cd045a02.jpg";